import tw, { styled } from "twin.macro";

export const StyledWrapperFitpoint = styled.div`
  ${tw`flex items-center gap-2 p-m justify-between bg-gradient-1 rounded-lg medium:(px-sm) large:(px-m)`};
`;
export const StyledWrapperFitpointText = styled.div`
  ${tw`flex items-center gap-2`};
`;
